export default from './RankPlaceRelevance';
